import * as React from "react";
import classnames from "classnames";
/* empty css                  */
import { ProductDetailPrice } from "../../../../../../../../../PriceSection/components/ProductDetailPrice/modules/EcommContent/components/PriceSection/components/ProductDetailPrice/ProductDetailPrice.js";
const PricingBadge = ({ className, id, purchaseTypePrice }) => /* @__PURE__ */ React.createElement("div", { id, className: classnames("pricing-badge", className) }, /* @__PURE__ */ React.createElement(
  ProductDetailPrice,
  {
    className: "pricing-badge__price",
    customSize: "small",
    isCentAmount: purchaseTypePrice.isCentAmount,
    originalPrice: purchaseTypePrice.originalPrice,
    discountedPrice: purchaseTypePrice.discountedPrice,
    currency: purchaseTypePrice.currency
  }
));
export {
  PricingBadge
};
//# sourceMappingURL=PricingBadge.js.map
